import { INTEGRATION_PARTNERS } from './constants'

export const isIntegrationConfigured = (appConfig) => {
  const isConfigSet = appConfig && appConfig.integrationPartner

  if (!isConfigSet) {
    return false
  }

  switch (appConfig.integrationPartner) {
    case INTEGRATION_PARTNERS.Slate:
      return appConfig.partnerConfiguration && !!appConfig.partnerConfiguration.instanceId
    case INTEGRATION_PARTNERS.SlateSourceFormat:
      return (
        appConfig.partnerConfiguration &&
        !!appConfig.partnerConfiguration.sourceFormatUrl &&
        !!appConfig.partnerConfiguration.serviceUserName &&
        !!appConfig.partnerConfiguration.serviceUserPassword
      )
    case INTEGRATION_PARTNERS.Scoir:
      return true
    default:
      return false
  }
}
